import { emission_factor_source_enum } from '@predium/enums';
import { Trans, getI18n } from 'react-i18next';

export const translateEmissionFactorSourceEnum = (enumValue: emission_factor_source_enum) => {
  switch (enumValue) {
    case emission_factor_source_enum.ARBEITSHILFE_85:
      return <Trans i18nKey="Enum_EmissionFactorSourceEnum-ARBEITSHILFE_85" />;
    case emission_factor_source_enum.GEMIS:
      return <Trans i18nKey="Enum_EmissionFactorSourceEnum-GEMIS" />;
    case emission_factor_source_enum.NATIONAL_ENERGY_LAW:
      return <Trans i18nKey="Enum_EmissionFactorSourceEnum-NATIONAL_ENERGY_LAW" />;
    case emission_factor_source_enum.UBA:
      return <Trans i18nKey="Enum_EmissionFactorSourceEnum-UBA" />;
  }
};

export const translateEmissionFactorSourceEnum_dynamic = (enumValue: emission_factor_source_enum) => {
  const t = getI18n().t;
  switch (enumValue) {
    case emission_factor_source_enum.ARBEITSHILFE_85:
      return t('Enum_EmissionFactorSourceEnum-ARBEITSHILFE_85');
    case emission_factor_source_enum.GEMIS:
      return t('Enum_EmissionFactorSourceEnum-GEMIS');
    case emission_factor_source_enum.NATIONAL_ENERGY_LAW:
      return t('Enum_EmissionFactorSourceEnum-NATIONAL_ENERGY_LAW');
    case emission_factor_source_enum.UBA:
      return t('Enum_EmissionFactorSourceEnum-UBA');
  }
};
